// extracted by mini-css-extract-plugin
module.exports = {"productEdit":"InputStyle_productEdit__329ML","inputContainer":"InputStyle_inputContainer__1_ZC8","note":"InputStyle_note__eYmIn","noteColumn":"InputStyle_noteColumn__1BYu2"};